import { format } from 'date-fns';
import { nl } from 'date-fns/locale';
import { enUS } from 'date-fns/locale';
import { Locale as DateFnsLocale } from 'date-fns';

// Define a union type for the valid locale keys
type LocaleKey = 'nl' | 'en' | 'en-US';

// Explicitly type the localeMap
const localeMap: Record<LocaleKey, DateFnsLocale> = {
    'nl': nl,
    'en': enUS,
    'en-US': enUS,
};

export function formatDate(date: Date | string): string {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return dateObj.toLocaleDateString('nl-NL'); // YYYY-MM-DD format in local timezone
}

export function shortenDate(date: Date): string {
    const dateObj = new Date(date);
    const day = dateObj.toLocaleDateString('nl-NL', { weekday: 'short' });
    const dateString = dateObj.toLocaleDateString('nl-NL', { day: 'numeric', month: 'short' });
    return Object.assign({ day: day, date: dateString });
}

export function formatShortDate(
    date: Date | string,
    locale: LocaleKey = 'nl'
): string {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return formatLocalizedDate(dateObj, 'd MMM yyyy', locale);
}

export function formatLocalizedDate(
    date: Date,
    formatString: string = "d MMMM yyyy",
    locale: LocaleKey = 'nl'
): string {
    try {
        return format(date, formatString, {
            locale: localeMap[locale] || localeMap['nl']
        });
    } catch (error) {
        console.warn('Date formatting error:', error);
        return format(date, formatString); // Fallback to default formatting
    }
}